var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSolarDangerTriangleBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31224 10.762C8.23024 5.587 9.68924 3 12.0002 3C14.3102 3 15.7702 5.587 18.6882 10.762L19.0522 11.406C21.4772 15.706 22.6902 17.856 21.5942 19.428C20.4982 21 17.7862 21 12.3642 21H11.6362C6.21424 21 3.50224 21 2.40624 19.428C1.31024 17.856 2.52324 15.706 4.94824 11.406L5.31224 10.762ZM12.0002 7.25C12.1992 7.25 12.3899 7.32902 12.5306 7.46967C12.6712 7.61032 12.7502 7.80109 12.7502 8V13C12.7502 13.1989 12.6712 13.3897 12.5306 13.5303C12.3899 13.671 12.1992 13.75 12.0002 13.75C11.8013 13.75 11.6106 13.671 11.4699 13.5303C11.3293 13.3897 11.2502 13.1989 11.2502 13V8C11.2502 7.80109 11.3293 7.61032 11.4699 7.46967C11.6106 7.32902 11.8013 7.25 12.0002 7.25ZM12.0002 17C12.2655 17 12.5198 16.8946 12.7073 16.7071C12.8949 16.5196 13.0002 16.2652 13.0002 16C13.0002 15.7348 12.8949 15.4804 12.7073 15.2929C12.5198 15.1054 12.2655 15 12.0002 15C11.735 15 11.4807 15.1054 11.2931 15.2929C11.1056 15.4804 11.0002 15.7348 11.0002 16C11.0002 16.2652 11.1056 16.5196 11.2931 16.7071C11.4807 16.8946 11.735 17 12.0002 17Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSolarDangerTriangleBold);
export default __webpack_public_path__ + "static/media/ic-solar_danger-triangle-bold.3bbef716dfab26cfce6e20438b4acd1e.svg";
export { ForwardRef as ReactComponent };